module.exports = __webpack_public_path__ + "static/img/base.15c9d45.png";


//////////////////
// WEBPACK FOOTER
// ./static/newStatic/img/guide/base.png
// module id = oOT3
// module chunks = 88